import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const WidgetContainer = styled.div`
  padding: 21px;
  background: ${colors.white};
  min-height: 100vh;
`

export const WidgetHeader = styled.div`
  // display: flex;
  // justify-content: space-between;
  // align-items: flex-start;
  margin-bottom: 32px;
  gap: 24px;
`

export const WidgetTitle = styled.h1`
  font-size: 1.5rem;
  color: ${colors.gray900};
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
`

export const WidgetDescription = styled.p`
  margin: 0;
  color: ${colors.gray600};
  font-size: 14px;
  line-height: 1.5;
`

export const ProjectSelectorContainer = styled.div`
  margin-top: 21px;
  min-width: 300px;
  flex-shrink: 0;
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
`

export const LoaderSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${colors.orange100};
  border-top-color: ${colors.orange500};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

export const LoaderText = styled.p`
  margin: 0;
  color: ${colors.gray600};
  font-size: 14px;
  font-weight: 500;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
`

export const ErrorText = styled.p`
  margin: 0;
  color: ${colors.gray600};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`
